import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7b12d078"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }

import { computed, PropType, reactive, ref } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import CmTable from '@/components/cmTable/index.vue'
import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import BtnIcon from '@/views/dashboard/_components/btn-icon/btn-icon.vue'
import PreText from '@/views/dashboard/group/hardware/_components/pre-text/pre-text.vue'
import { FormType, ObjectFormItem } from '@/components/cmForm/types'
import { HardwareService, FetchOptions, HardwareItem, HardwareListSliceFilters } from '../hardware.service'
import {
  HARDWARE_DISK_CAPACITY_LABELS,
  HARDWARE_MEMORY_SPEC_LABELS,
  resolveHardwareDiskCapacityRangeMb,
  resolveHardwareMemorySpecRangeMb,
} from '../_utils/hardware-fixed-capacity-buckets'
import { TableViewMode, TableViewModeType } from '@/views/dashboard/_enum/table-view-mode'
import { listCol } from '@/utils/list-columns-i18n'
import { bytesToSize } from '@/utils/tool'
import { formatTimeStamp } from '@/utils/time'
import { computerInfoCols } from '@/views/dashboard/data-safe/ransomware-protection/types/ransomware-incident'

interface HardwarePieDatum {
  name: string
  value: number
  device_ids?: string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'hardware-terminal-list',
  props: {
  hasPermission: {
    type: Boolean,
    default: true,
  },
  viewMode: {
    type: String as PropType<TableViewModeType>,
    default: TableViewMode.preview,
  },
  /** 抽屉打开时由父组件传入，与饼图联动 */
  initialHardwareFilters: {
    type: Object as PropType<HardwareListSliceFilters | null>,
    default: null,
  },
  cpuBrandOptions: {
    type: Array as PropType<HardwarePieDatum[]>,
    default: () => [],
  },
  mainboardOptions: {
    type: Array as PropType<HardwarePieDatum[]>,
    default: () => [],
  },
},
  emits: ["viewAll", "viewHistory"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const { t, locale } = useI18n()
const injector = useReflectiveInjector([HardwareService])
const hardwareService = injector.get(HardwareService)

const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)

const initFilters = props.initialHardwareFilters
const queryParams = reactive<FetchOptions>({
  keyword: '',
  page: 1,
  limit: props.viewMode === TableViewMode.preview ? 10 : 20,
  sort: '',
  asc: false,
  cpu: initFilters?.cpu,
  disk_capacity: initFilters?.disk_capacity,
  memory_spec: initFilters?.memory_spec,
  mainboard: initFilters?.mainboard,
  device_ids: initFilters?.device_ids?.length ? [...initFilters.device_ids] : [],
})

const formColumns = computed<ObjectFormItem<typeof queryParams, 'cpu' | 'disk_capacity' | 'memory_spec' | 'mainboard'>>(() => {
  void locale.value
  return {
    cpu: {
      colOpt: { style: 'flex: 0 0 160px' },
      label: t('terminalHardware.filterCpuBrand'),
      hiddenAllLabel: true,
      type: FormType.Select,
      dictData: props.cpuBrandOptions.map(o => ({ label: o.name, value: o.name })),
      selectOpt: { clearable: true },
      outSearchFiledFlag: true,
      events: {
        change: () => {
          queryParams.device_ids = []
          void handleQuery()
        },
      },
    },
    disk_capacity: {
      colOpt: { style: 'flex: 0 0 160px' },
      label: t('terminalHardware.filterDiskCapacity'),
      hiddenAllLabel: true,
      type: FormType.Select,
      dictData: HARDWARE_DISK_CAPACITY_LABELS.map(label => ({ label, value: label })),
      selectOpt: { clearable: true },
      outSearchFiledFlag: true,
      events: {
        change: () => handleQuery(),
      },
    },
    memory_spec: {
      colOpt: { span: 12 },
      label: t('terminalHardware.filterMemorySpec'),
      type: FormType.Select,
      dictData: HARDWARE_MEMORY_SPEC_LABELS.map(label => ({ label, value: label })),
      selectOpt: { clearable: true },
    },
    mainboard: {
      colOpt: { span: 12 },
      label: t('terminalHardware.filterMotherboard'),
      type: FormType.Select,
      dictData: props.mainboardOptions.map(o => ({ label: o.name, value: o.name })),
      selectOpt: { clearable: true },
    },
  }
})

const pageOption = {
  pageNumName: 'page',
  pageSizeName: 'limit',
}

const tableOpt = computed(() => {
  void locale.value
  return {
    columns: [
      ...computerInfoCols(false, true, t),
      { prop: 'system_name', label: t('terminalHardware.systemName'), minWidth: 150,showOverflow: true },
      { prop: 'computer_model', label: t('terminalHardware.computerModel'), minWidth: 200,showOverflow: true },
      { prop: 'product_id', label: t('terminalHardware.productId'), minWidth: 150,showOverflow: true },
      { prop: 'sn_code', label: t('terminalHardware.snCode'), minWidth: 140,showOverflow: true },
      { prop: 'cpu', label: t('terminalHardware.cpu'), columnOpt: { minWidth: 250 },v: 250,showOverflow: true },
      { prop: 'memory_capacity', label: t('terminalHardware.changeTypeMemoryCapacity'),minWidth: 200,showOverflow: true },
      { prop: 'memory_info', label: t('terminalHardware.memoryInfo'), minWidth: 200,showOverflow: true },
      { prop: 'main_bord', label: t('terminalHardware.changeTypeMotherboard'), minWidth: 200,showOverflow: true },
      { prop: 'hard_disk', label: t('terminalHardware.changeTypeHardDisk'), minWidth: 200,showOverflow: true },
      {
        prop: 'whole_disk_total',
        label: t('terminalHardware.wholeDiskTotalGb'),
        columnOpt: { minWidth: 180 },
        showOverflow: true,
        formatter: (_row, val) => bytesToSize(Number(val) * 1024 * 1024),
      },
      { prop: 'graphics_card', label: t('terminalHardware.changeTypeGraphicsCard'), minWidth: 200,showOverflow: true },
      { prop: 'network_card', label: t('terminalHardware.changeTypeNetworkCard'), minWidth: 200,showOverflow: true },
      { prop: 'audio_card', label: t('terminalHardware.changeTypeAudioCard'), minWidth: 200,showOverflow: true },
      { prop: 'display', label: t('terminalHardware.changeTypeDisplay'), minWidth: 200,showOverflow: true },
      { prop: 'current_startup_time', label: t('groupClient.columnCurrentStartupTime'), minWidth: 160, formatter: (_row: any, value: number) => formatTimeStamp(value, 'YYYY-MM-DD HH:mm') || '—' },
      { prop: 'last_offline_time', label: t('groupClient.columnLastOfflineTime'), minWidth: 160, formatter: (_row: any, value: number) => formatTimeStamp(value, 'YYYY-MM-DD HH:mm') || '—' },
      { prop: 'change_count', label: t('terminalHardware.changeRecord'),minWidthwidth: 100,showOverflow: true },
    ],
    rowKey: 'device_id',
    bodyStyle: props.viewMode === TableViewMode.full ? { padding: '10px 16px' } : { padding: 0 },
    showActionBar: false,
    showSearch: false,
    showRightToolbar: true,
    height: props.viewMode === TableViewMode.preview ? undefined : '100%',
    path: 'list',
    totalPath: 'total',
    usePagination: false,
    disableScrollLoad: props.viewMode === TableViewMode.preview,
    scrollLoadThreshold: 10,
    scrollLoadDelay: 100,
  }
})

function buildListFilterPayload () {
  const q = queryParams
  const memR = resolveHardwareMemorySpecRangeMb(q.memory_spec)
  const diskR = resolveHardwareDiskCapacityRangeMb(q.disk_capacity)
  const deviceIds = Array.isArray(q.device_ids) && q.device_ids.length > 0 ? q.device_ids : undefined
  return {
    keyword: q.keyword || undefined,
    sort: q.sort || undefined,
    asc: q.asc,
    cpu: deviceIds ? undefined : (q.cpu || undefined),
    mainboard: q.mainboard || undefined,
    memory_spec: !memR && q.memory_spec ? q.memory_spec : undefined,
    disk_capacity: !diskR && q.disk_capacity ? q.disk_capacity : undefined,
    memory_capacity_min: memR?.minMb,
    memory_capacity_max: memR?.maxMb,
    whole_disk_total_min: diskR?.minMb,
    whole_disk_total_max: diskR?.maxMb,
    device_ids: deviceIds,
  }
}

function getListApi (params: any) {
  return hardwareService.fetchHardwareData({
    ...params,
    ...buildListFilterPayload(),
  })
}

async function handleSearch(value: string) {
  queryParams.keyword = value
  queryParams.page = 1
  await refreshList()
}

async function handleQuery() {
  queryParams.page = 1
  await refreshList()
}

function handleReset() {
  queryParams.keyword = ''
  queryParams.sort = ''
  queryParams.asc = false
  queryParams.memory_spec = undefined
  queryParams.mainboard = undefined
  queryParams.cpu = undefined
  queryParams.disk_capacity = undefined
  queryParams.device_ids = []
  queryParams.page = 1
  void refreshList()
}

function handlerSort({ prop, order }: { prop: string; order: string }) {
  if (order === 'ascending') {
    queryParams.asc = true
  } else {
    queryParams.asc = false
  }
  queryParams.sort = prop
  void refreshList()
}

function handlerExport () {
  hardwareService.download(0, { ...queryParams, ...buildListFilterPayload() }, t('terminalHardware.exportFilenamePrefix'))
}

function handleViewAll() {
  emit('viewAll')
}

function refreshData() {
  void refreshList()
}

__expose({
  refreshData,
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createBlock(CmTable, {
    ref_key: "tableRef",
    ref: tableRef,
    "table-opt": tableOpt.value,
    api: getListApi,
    "page-option": pageOption,
    modelValue: queryParams,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams) = $event)),
    "has-permission": __props.hasPermission,
    onSortChange: handlerSort
  }, {
    header: _withCtx(() => [
      _createVNode(SearchFilterBar, {
        modelValue: queryParams,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams) = $event)),
        "form-columns": formColumns.value,
        class: _normalizeClass(__props.viewMode === _unref(TableViewMode).preview ? 'cm-ui-pt15' : ''),
        "show-search": true,
        "search-placeholder": _ctx.$t('terminalHardware.searchPlaceholder'),
        "popover-threshold": 0,
        onSearch: handleSearch,
        onQuery: handleQuery,
        onReset: handleReset
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            plain: "",
            onClick: handlerExport
          }, {
            default: _withCtx(() => [
              _createVNode(BtnIcon, { "icon-name": "export_h" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('terminalHardware.exportInfo')), 1)
            ]),
            _: 1
          }),
          (__props.viewMode === _unref(TableViewMode).preview)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                size: "small",
                plain: "",
                onClick: handleViewAll
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('commonPage.viewAll')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "form-columns", "class", "search-placeholder"])
    ]),
    change_count: _withCtx(({ row }: { row: HardwareItem }) => [
      (row.change_count)
        ? (_openBlock(), _createBlock(_component_el_link, {
            key: 0,
            type: "primary",
            onClick: _withModifiers(($event: any) => (emit('viewHistory', row)), ["prevent"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(row.change_count), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_1, "0"))
    ]),
    memory_spec: _withCtx(({ row }: { row: HardwareItem }) => [
      _createElementVNode("span", null, _toDisplayString(row.memory_spec || '—'), 1)
    ]),
    memory_info: _withCtx(({ row }: { row: HardwareItem }) => [
      _createVNode(PreText, {
        content: row.memory_info
      }, null, 8, ["content"])
    ]),
    memory_capacity: _withCtx(({ row }: { row: HardwareItem }) => [
      _createElementVNode("span", null, _toDisplayString(row.memory_capacity != null && row.memory_capacity > 0
            ? `${(row.memory_capacity / 1024).toFixed(2)}GB`
            : '—'), 1)
    ]),
    main_bord: _withCtx(({ row }: { row: HardwareItem }) => [
      _createVNode(PreText, {
        content: row.main_bord
      }, null, 8, ["content"])
    ]),
    hard_disk: _withCtx(({ row }: { row: HardwareItem }) => [
      _createVNode(PreText, {
        content: row.hard_disk
      }, null, 8, ["content"])
    ]),
    graphics_card: _withCtx(({ row }: { row: HardwareItem }) => [
      _createVNode(PreText, {
        content: row.graphics_card
      }, null, 8, ["content"])
    ]),
    network_card: _withCtx(({ row }: { row: HardwareItem }) => [
      _createVNode(PreText, {
        content: row.network_card
      }, null, 8, ["content"])
    ]),
    audio_card: _withCtx(({ row }: { row: HardwareItem }) => [
      _createVNode(PreText, {
        content: row.audio_card
      }, null, 8, ["content"])
    ]),
    display: _withCtx(({ row }: { row: HardwareItem }) => [
      _createVNode(PreText, {
        content: row.display
      }, null, 8, ["content"])
    ]),
    _: 1
  }, 8, ["table-opt", "modelValue", "has-permission"]))
}
}

})